export enum ColorType {
  Green = 'Green',
  Red = 'Red'
}
